
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m13.371 7.567-9.621-5.555a.5.5 0 0 0-.75.433v11.11a.5.5 0 0 0 .75.433l9.621-5.555a.5.5 0 0 0 0-.866Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  